import { copyTxt } from '@/utils/native'
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

export function getUrlKey(name) {
  const value = (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
    location.href
  ) || '')[1]
  if (value) {
    return decodeURIComponent(value.replace(/\+/g, '%20'))
  } else {
    return null
  }
}

export function copyText(text) {
  if (copyTxt(text)) {
    return
  }
  const copyInput = document.createElement('INPUT')
  copyInput.type = 'text'
  copyInput.style.width = '1px'
  copyInput.style.height = '1px'
  copyInput.style.border = 0
  copyInput.style.outline = 0

  document.body.appendChild(copyInput)
  copyInput.value = text
  copyInput.select()
  const result = document.execCommand('Copy')
  document.body.removeChild(copyInput)
  return result
}
export function getRadomStr() {
  return generateMixed(20)
}
// 获取n位随机数,随机来源chars
var chars = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
]

function generateMixed(n) {
  var res = ''
  for (var i = 0; i < n; i++) {
    var id = Math.ceil(Math.random() * 35)
    res += chars[id]
  }
  return res
}
export function getAmount(a) {
  if (a > 100000000) {
    return a.d(100000000) + 'E'
  } else if (a > 1000000) {
    return a.d(1000000) + 'M'
  } else if (a > 1000) {
    return a.d(1000) + 'K'
  }
  return a
}



// WEBPACK FOOTER //
// ./src/utils/util.js